/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GalleryDto } from '../../models/gallery-dto';
import { GalleryShowResponse } from '../../models/gallery-show-response';

export interface PostGalleryCreate$Params {
      body: GalleryDto
}

export function postGalleryCreate(http: HttpClient, rootUrl: string, params: PostGalleryCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postGalleryCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GalleryShowResponse>;
    })
  );
}

postGalleryCreate.PATH = '/v1/gallery';
